import React from "react";
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function formatDate(value) {
  if (!value) return "";
  try {
    return new Date(value).toLocaleString("pt-BR");
  } catch {
    return String(value);
  }
}

export function TeacherCommentsDialog({ open, onClose, teacher, comments }) {
  const items = comments || [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        Observações dos alunos
        {teacher?.teacherName ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {teacher.teacherName}
            {teacher.subjects ? ` — ${teacher.subjects}` : ""}
          </Typography>
        ) : null}
        <IconButton
          aria-label="Fechar"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {items.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            Nenhuma observação registrada para este professor nesta turma.
          </Typography>
        ) : (
          items.map((item, idx) => (
            <Box key={`${item.aluno_id || idx}-${item.submitted_at || idx}`}>
              {idx > 0 ? <Divider sx={{ my: 2 }} /> : null}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                <Typography variant="subtitle2">
                  {item.student_name || "Aluno"}
                </Typography>
                {item.submitted_at ? (
                  <Chip
                    size="small"
                    variant="outlined"
                    label={formatDate(item.submitted_at)}
                  />
                ) : null}
              </Box>
              <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                {item.answer}
              </Typography>
            </Box>
          ))
        )}
      </DialogContent>
    </Dialog>
  );
}
